// extracted by css-extract-rspack-plugin
export default {"projectLink":"ProjectV2-module__projectLink__ElNo9"};